import React from 'react';
import { History } from 'history';
import BaseCreate from '../base/base-create.component'; 
import Model from './eventquiz-model';  //editable..


interface IProps { 
    history: History;
    caption?: string;
}

interface IState {
    datarow: Model;
    errors: any;
}

export default class EventquizCreate extends  React.Component<IProps, IState> {
    constructor(props:IProps) {
        super(props);  
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
        }
        this.onChange = this.onChange.bind(this);
    }
    
    private onError = (data: any) => {
        this.setState({errors: data});
    }
    
    private onChange(fieldName: string, value?: string) { 
        const nextState = {
            ...this.state, datarow: {
                ...this.state.datarow, [fieldName]: value
            }
        }
        this.setState(nextState);
    }

    render() {
        return (
            //editable.. 
            <BaseCreate history={this.props.history} caption={this.props.caption} 
                model={Model} datarow={this.state.datarow} onError={this.onError} >
                
            </BaseCreate>
        );
    }     
     
}